import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";
import ButtonArrow from "../../components/ButtonArrow";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import AuvikStatisticsCard from "./AuvikStatisticsCard.jsx";
import Loader from "../../components/Loader";

export default function Auvik() {
  const { apiUrl } = useContext(AuthContext);
  const [alertsPerSite] = useState({});
  const { t } = useTranslation();

  const getTenantsLive = async () => {
    try {
      const res = await axios.get(`${apiUrl}auvik/tenants_live`, {
        withCredentials: true,
      });
      return res.data;
    } catch (error) {
      return [];
    }
  };

  const tenantsLive = useQuery({
    queryKey: ["auvik"],
    queryFn: getTenantsLive,
  });

  const tenants = Array.isArray(tenantsLive.data) ? tenantsLive.data : [];

  if (tenantsLive.isLoading) {
    return <Loader />;
  }

  if (tenants.length === 0) {
    return (
            <div className="ecp-container">
            <div className="ecp-container-content-error">
                <div className="error-container">
                    <img src='../assets/ecp_error.svg' alt="icône d'erreur" />
                    <div className="error-container-text">
                    <h1 className="page-title">
                        {t("Pas de données Auvik disponibles")}
                    </h1>
                    <p className="page-link_home">
                        <Link to="/"> {t("Revenir à l'accueil")}</Link>
                    </p>
                    </div>
                </div>
            </div>
        </div>
    );
  }

  return (
    <section className="statistics-auvik auvik">
      <div className="page-logo">
        <img src="/assets/auvik_logo.png" alt="Logo de Auvik" />
        <h1 className="page-title">Auvik</h1>
        <ButtonArrow url="https://auth.auvik.com/" />
      </div>
      <h2 className="auvik-title-sites">{t("Sites disponibles")} :</h2>
      <section className="statistics-auvik-container">
        {tenants.map((tenant) => (
          <AuvikStatisticsCard
            key={tenant.auvik_id}
            firstTenant={tenants.length > 1 ? tenants[0] : null}
            statisticsAuvik={tenant}
            alerts={alertsPerSite}
          />
        ))}
      </section>
    </section>
  );
}
